// https://usehooks-ts.com/react-hook/use-debounce
import { useEffect, useState } from 'react';

export const useDebounce = <T>(
  value: T,
  delay?: number,
  onDebounce?: (val: T) => void,
): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      onDebounce?.(value);
    }, delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay, onDebounce]);

  return debouncedValue;
};
